import {AfterViewInit, Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ButtonConfig } from '@collab/comp-library';
import { StaticTableComponent } from '../static-table/static-table.component';
import { FilesUploadedTableI } from './model/filesUploadedTable';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements AfterViewInit {
  @Input() public imagePath?: string;
  @Input() public dragDropText?: string;
  @Input() public typeOfFile?: string;
  @Input() public files!: Array<File>;
  @Input() public acceptedFileType!: string;
  @Input() public formControlName!: string;
  @Input() public errorExt!: boolean;
  @Input() public isSubmitted!: boolean;
  @Input() dataTypeList!: [{ name: string; value: string }];
  @Input() public noNotes!: boolean;
  @Input() public footerNotes?: string;
  @Input() public isMultiple!: boolean;
  @Input() public fileSize: number | null = null;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() public onExtLink: EventEmitter<any> = new EventEmitter<any>();

    @ViewChildren('fileInput') fileInput!: QueryList<any>;

    @ViewChild(StaticTableComponent, { static: false }) public staticTableComponent!: StaticTableComponent;

    public selectedRowDataValue: any;
    public errorExtn: string[] = [];
    public uniquErrorExtn: string[] = [];
    public isMaxSizeExceeded = false;
    public totalFilesize = 0;
    public tableData: FilesUploadedTableI[] = [];
    public isErrorExtn!: boolean;
    public uploadAllTestCasesFilesError = false;
    public defectLogsCount = false;
    public raOutputFileCount = false;
    public testExecutionLogsCount = false;
    public duplicateFilesUploadedError = false;
    public browseButtonConfig: ButtonConfig = {
        text: 'Upload File',
        buttonType: 'secondary',
        buttonSize: 'small',
        iconURL: 'icon-Plus',
        iconPosition: 'left',
        imageUrl: '',
        linkURL: ''
    };

  constructor(private activatedRoute: ActivatedRoute) {}
  converToMb(bytes: number) {
    return bytes * 1000000;
  }
  ngAfterViewInit(): void {
      if(this.isMultiple){
        this.fileInput.first.nativeElement.setAttribute('multiple', true)
      }
    }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  public ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params?.['uploadedFile']) {
        this.tableData.push({
          documentName: params?.['uploadedFile'],
          documentSize: params?.['fileSize'],
        });
      }
    });
    this.isErrorExtn = this.errorExt;
    this.clearAllTableData();
  }
  /**
   * this method will upload the file
   * @returns {void}
   * @param {*} file
   * @memberof FileUploadComponent
   */
  public uploadFile(file: any): void {
    if (this.isUploadDisabled) {
      return;
    }
    this.uniquErrorExtn = [];
    this.errorExtn = [];
    for (let index = 0; index < file?.length; index++) {
      this.isMaxSizeExceeded = false;
      if (this.isMultiple) {
        this.totalFilesize = this.totalFilesize + file[index].size;
      } else {
        this.totalFilesize = file[index].size;
      }
      if (
        this.totalFilesize <= 31457280 ||
        (this.fileSize && this.totalFilesize <= this.converToMb(this.fileSize))
      ) {
        const element = file[index];
        const fileExtn = '.' + element.name.split('.').pop();
        const acceptedFileTypeArr = this.acceptedFileType.split(',');

                if (acceptedFileTypeArr.indexOf(fileExtn) === -1) {
                    this.errorExtn.push(fileExtn.slice(1));
                    this.uniquErrorExtn = [...new Set(this.errorExtn)];

                    this.totalFilesize = Number(this.totalFilesize) < 0 ? 0 : Number(this.totalFilesize) - Number(element.size);

                } else {
                    this.files = Array.from(this.files);

                    if ((this.files && this.files.length < 1) || (this.files && [...this.files].indexOf(element.name) === -1)) {
                        this.files.push(element);
                    } else {
                        alert('duplicate file');
                    }

                    this.tableData = [...this.tableData, { documentName: element.name, documentSize: element.size }];
                }
            } else {
                this.isMaxSizeExceeded = true;
                this.totalFilesize = this.totalFilesize - file[index].size;
                return;
            }
        }

        this.tableData.forEach((_record, index) => {
            this.tableData[index]['id'] = index.toString();
        })
    }

    get isUploadDisabled(): boolean {
      return !this.isMultiple && this.files?.length >= 1;
    }

    public deleteRow(id: any) {
        this.totalFilesize = Number(this.totalFilesize) < 0 ? 0 : Number(this.totalFilesize) - Number(this.tableData.find(item => item.id === id)!.documentSize);
        this.tableData.splice(this.tableData.findIndex(item => item.id === id), 1);
        this.files.splice(Number(id), 1);
        this.fileInput.first.nativeElement.value = '';
        this.fileInput.last.nativeElement.value = '';
    }

    public clearAllTableData() {
      if(this.fileInput?.first?.nativeElement){
        this.fileInput.first.nativeElement.value = '';
      }
      this.tableData.length = 0;
      this.files.length = 0;
      this.isMaxSizeExceeded = false;
      this.uniquErrorExtn = [];
    }
    public OnLinkExternalClick() {
      this.onExtLink.emit();
  }
}
